import type { MyAccessSite } from '../../services/scheduleService';

/**
 * The sites an inspector can take from the Schedule tab (JIM-1020-09, Jim
 * 2026-10-20): in their groups, not theirs yet, and on a live project.
 */
export function claimableSites(
  groupSites: MyAccessSite[] | undefined
): MyAccessSite[] {
  return (groupSites ?? []).filter((s) => s.status === 'active');
}

type PlanService = {
  claimSite: (siteId: string) => Promise<unknown>;
  addToPlan: (siteId: string, scheduledDate: string) => Promise<void>;
};

/** Claim first, then plan — the plan only takes the inspector's own sites. */
export async function claimAndAdd(
  service: PlanService,
  siteId: string,
  scheduledDate: string
): Promise<void> {
  await service.claimSite(siteId);
  await service.addToPlan(siteId, scheduledDate);
}

/**
 * Whether a site row offers Claim (Jim 10/23, JIM-1023-12): never on a site
 * already assigned to the signed-in inspector — "if someone assigned you as
 * the inspector, it's already claimed". Claim is for other people's sites.
 */
export function showClaim(
  site: { assignedInspectorId?: string | null },
  userId: string | undefined
): boolean {
  return (
    !userId || !site.assignedInspectorId || site.assignedInspectorId !== userId
  );
}
